import React, { useState } from "react";
import iconAndroid from "../../assets/images/home/android.png";
import iconApple from "../../assets/images/home/apple.png";
import iconAppleW from "../../assets/images/home/apple-w.png";
import iconDiscord from "../../assets/images/home/discord.png";
import iconWechat from "../../assets/images/home/wechat.png";
import DownItem from "./DownItem/DownItem";
import DownItemMobile from "./DownItemMobile/DownItem";
import Button from "../../Components/Button/Button";
import Carousel from "../../Components/Carousel/Carousel";
import img_qrCode from "../../assets/images/qrCode.png";
import img_qriOS from "../../assets/images/qriOS.png";
import img_qrDiscord from "../../assets/images/qrDiscord.png";
import img_qrWechat from "../../assets/images/qrWechat.png";
import AvatarSlider from "../../Components/AvatarSlider/index";
import { useTranslation } from "react-i18next";
import "./home.css";
import "./homeMedium.css";

function Main() {
  const [showWeChatQR, setShowWeChatQR] = useState(false);
  const { t, i18n } = useTranslation();
  const handleDownloadClick = (type) => {
    if (type === "ios") {
      const url = `https://apps.apple.com/app/id6736935182`;
      window.location.href = url;
    } else if (type === "android") {
      // TODO: 替换为实际的 APK 下载链接
      const url = `https://example.com/download/app.apk`; 
      window.location.href = url;
    }
    console.log("下载按钮点击");
  };

  const downloadClick = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const isChineseLanguage = i18n.language.startsWith('zh');

  const handleWeChatClick = () => {
    setShowWeChatQR(true);
  };

  return (
    <div className="main-container">
      <section className="section1-wrapper">
        <div className="section1 maxw">
          <div className="left-side-wrapper col-sm-12 col-md-6">
            <div className="left-side-container ikiai-view">
              <div className="ikiai-title">{t("home.title")}</div>
              <div className="ikiai-sub-title">{t("home.description")}</div>
              <div className="down-view">
                <DownItem
                  icon={iconApple}
                  title={t("home.download.ios")}
                  onClick={() => handleDownloadClick("ios")}
                  badge="QR"
                  qrCode={img_qriOS}
                />
                <DownItem
                  icon={iconAndroid}
                  title={t("home.download.android")}
                  onClick={() => handleDownloadClick("android")}
                  badge="QR"
                  qrCode={img_qrCode}
                />
                <DownItem
                  icon={iconDiscord}
                  title={t("home.download.discord")}
                  onClick={() => window.open('https://discord.gg/a8GXTmtMZe', '_blank')}
                  badge="QR"
                  qrCode={img_qrDiscord}
                />
                {isChineseLanguage && (
                  <DownItem
                    icon={iconWechat}
                    title={t("home.download.wechat")}
                    onClick={handleWeChatClick}
                    badge="QR"
                    qrCode={img_qrWechat}
                  />
                )}
              </div>
              <div className="down-view-mobile">
                <DownItemMobile
                  style={{ marginBottom: "6px" }}
                  icon={iconAppleW}
                  title={t("home.download.ios")}
                  onClick={() => handleDownloadClick("ios")}
                  badge="QR"
                  qrCode={img_qriOS}
                  type="dark"
                />
                <DownItemMobile
                  style={{ marginBottom: "6px" }}
                  icon={iconAndroid}
                  title={t("home.download.android")}
                  onClick={() => handleDownloadClick("android")}
                  badge="QR"
                  qrCode={img_qrCode}
                />
                <DownItemMobile
                  style={{ marginBottom: "6px" }}
                  icon={iconDiscord}
                  title={t("home.download.discord")}
                  onClick={() => window.open('https://discord.gg/a8GXTmtMZe', '_blank')}
                  badge="QR"
                  qrCode={img_qrDiscord}
                />
                {isChineseLanguage && (
                  <DownItemMobile
                    icon={iconWechat}
                    title={t("home.download.wechat")}
                    onClick={handleWeChatClick}
                    badge="QR"
                    qrCode={img_qrWechat}
                  />
                )}
              </div>
            </div>
          </div>
          <div className="right-side-wrapper">
            <img
              className="right-side-container"
              src={require("../../assets/images/home/section1-left.webp")}
            />
          </div>
        </div>
      </section>

      <section className="section2-wrapper">
        <div className="section2">
          <div className="section2-title" style={{ marginBottom: "24px" }}>
            {t("home.subTile1")}
          </div>
          <Button
            style={{ marginBottom: "100px" }}
            title={t("home.btn.try")}
            onClick={downloadClick}
          />
          <AvatarSlider />
        </div>
      </section>

      {/* <section className="section3-wrapper"> */}
      <div className="statements-users">
        <div className="statements-title">{t("home.subTile2")}</div>
        <Carousel />
      </div>
      {/* </section> */}

      <div
        style={{
          marginTop: "60px",
          marginBottom: "100px",
        }}
      >
        <Button title={t("home.btn.try")} onClick={downloadClick} />
      </div>

      <section className="bottom-bg">
        {/* <img src={require("../../assets/images/home/bottomBg.png")} /> */}
        <img src={require("../../assets/images/home/bottomBg.webp")} />
      </section>

      {/* Add WeChat QR Popup */}
      {showWeChatQR && (
        <div 
          className="wechat-qr-popup"
          onClick={() => setShowWeChatQR(false)}
        >
          <div className="wechat-qr-content" onClick={e => e.stopPropagation()}>
            <img src={img_qrWechat} alt="WeChat QR Code" />
          </div>
        </div>
      )}
    </div>
  );
}

export default Main;
